import {Boolean, Number, Record, Static } from "runtypes";

export const EvaluationRequestRuntype = Record({
  schoolId: Number,
  sportId: Number,
});

export interface IEvaluationRequest
  extends Static<typeof EvaluationRequestRuntype> {
  coachId?: number; // ✅ Ensure `coachId` is optional in TypeScript
}

  export const StartTourRequestRuntype = Record({
    userId: Number,
    restartTour: Boolean,
  });
  
  export interface IStartTourRequest
    extends Static<typeof StartTourRequestRuntype> {}


// WEBPACK FOOTER //
// ./src/api/types/IEvaluationRequest.ts